/**
 * Prefer BaaS field-level 409 messages (`errors.program_code`, `errors.owner_entity_id`, etc.)
 * and Problem Details `detail` over a generic toast.
 *
 * Note: 409 is NOT only program_code — also owner_entity_id, root_account_id,
 * link_hml_instance_id, create_hml_twin, instance (setup), duplicate_request, etc.
 */
export const formatBaasCreateConflictMessage = (error, fallback = null) => {
  const fieldErrors = error?.errors || error?.data?.errors;
  if (fieldErrors && typeof fieldErrors === "object") {
    const messages = Object.entries(fieldErrors)
      .flatMap(([field, value]) => {
        const list = Array.isArray(value) ? value : [value];
        return list
          .map((entry) => String(entry || "").trim())
          .filter(Boolean)
          .map((entry) => (entry.includes(":") ? entry : `${field}: ${entry}`));
      })
      .filter(Boolean);
    if (messages.length > 0) {
      return messages.join(" ");
    }
  }

  const detail = String(error?.detail || error?.data?.detail || error?.message || "").trim();
  if (detail) return detail;

  const code = error?.code || error?.data?.error;
  if (code === "duplicate_request") {
    return "A request with the same X-Idempotency-Key is already in progress or completed.";
  }

  return fallback;
};
